/**
 * Where `value` sits along `points` (ascending), as a fractional index: an exact match is
 * its own index, a value between two points lands proportionally between them, and one
 * outside the range is pinned to the nearer end. -1 when there is nothing to place.
 *
 * One home for this (ASB-2995): the modeled page's chart marker and the Slider's thumb
 * both place an off-mark score with it, and the e2e check holds them within 2px.
 */
export function fractionalIndex(points, value) {
	const n = points.length;
	if (value == null || n === 0) return -1;
	if (value <= points[0]) return 0;
	if (value >= points[n - 1]) return n - 1;
	for (let i = 0; i < n - 1; i++) {
		if (value === points[i]) return i;
		if (value < points[i + 1]) return i + (value - points[i]) / (points[i + 1] - points[i]);
	}
	return n - 1;
}
